module.exports = __webpack_public_path__ + "img/ligneh.e596f486.svg";